import {FormValidation} from "./FormValidation";

export class CloudflareTurnstille {
    /**
     * Check if turnstille response token is found in input
     *
     * @param {jQuery} $form
     * @returns {boolean}
     */
    static validate($form) {
        var $ = jQuery;
        // Hide cf error
        $('.cf-error').removeClass('show');
        $('.cf-turnstile').removeClass('error');

        if (!CloudflareTurnstille.canValidate($form)) {
            return true;
        }
        //
        var $cfTurnstile = $form.find('input[name="cf-turnstile-response"]');
        var resp = "";

        if ($cfTurnstile.length > 0) {
            resp = $cfTurnstile.val();
        }

        if (resp.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    static onLoad() {
        // var $ = jQuery;
        // //
        // window.setTimeout(function() {
        //     console.log("Timeout");
        //     //
        //     $('.cf-turnstile').find('iframe').on('load', function () {
        //         console.log("Loaded");
        //     });
        // }, 3000);
    }

    static handleInvalidForm($form) {
        var $ = jQuery;
        FormValidation.removeLoadingButton($form);
        //
        // Show error
        $('.cf-error').addClass('show');
        $form.find('.cf-turnstile').addClass('error');
    }

    /**
     * @param {jQuery} $form
     * @returns {boolean}
     */
    static canValidate($form) {
        var $cfTurnstile = $form.find('input[name="cf-turnstile-response"]');

        if (!CF_TURNSTILLE_ENABLED) {
            return false;
        }

        if ($cfTurnstile.length > 0) {
            return true;
        } else {
            return false;
        }
    }

}